import Box from "@ui-kit/layout/Box/Box.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Accordion, {
  AccordionProps,
} from "@ui-kit/disclosure/Accordion/Accordion.web";
import { AccordionItemProps } from "@ui-kit/disclosure/Accordion/AccordionItem.web";
import React from "react";

export type PaymentTypeAccordionProps = AccordionProps & {
  value?: string[];
  onValueChange?: (details: { value: string[] }) => void;
};

function PaymentTypeAccordion({
  children,
  ...props
}: PaymentTypeAccordionProps) {
  return (
    <Box>
      <Accordion {...props} multiple={false} collapsible={false}>
        {children}
      </Accordion>
    </Box>
  );
}

export default PaymentTypeAccordion;

PaymentTypeAccordion.Item = PaymentTypeAccordionItem;
PaymentTypeAccordion.Trigger = PaymentTypeAccordionButton;
PaymentTypeAccordion.Content = PaymentTypeAccordionPanel;

function PaymentTypeAccordionItem({ children, ...props }: AccordionItemProps) {
  return (
    <Accordion.Item
      backgroundColor="bg.muted"
      border="1px solid"
      borderColor="border"
      borderRadius="none"
      marginTop="-1px"
      _first={{
        borderRadius: "4px 4px 0px 0px",
        marginTop: "0px",
      }}
      _last={{
        borderRadius: "0px 0px 4px 4px",
      }}
      _only={{
        borderRadius: "4px",
      }}
      {...props}
    >
      {children}
    </Accordion.Item>
  );
}

function PaymentTypeAccordionButton({
  isExpanded,
  children,
  onExpand,
}: {
  isExpanded: boolean;
  children: React.JSX.Element;
  onExpand?: () => void;
}) {
  return (
    <Accordion.Trigger
      backgroundColor="bg"
      color="fg"
      _open={{
        backgroundColor: "bg.muted",
        color: "fg",
      }}
      iconPosition="none"
      isExpanded={isExpanded}
      onExpand={onExpand}
    >
      <Box mr="xs" aria-hidden="false">
        {isExpanded ? <SelectedRadioSymbol /> : <UnselectedRadioSymbol />}
      </Box>
      {children}
    </Accordion.Trigger>
  );
}

function PaymentTypeAccordionPanel({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Accordion.Content
      backgroundColor="bg.subtle"
      color="fg"
      padding="8px 16px 16px 16px"
    >
      {children}
    </Accordion.Content>
  );
}

export function UnselectedRadioSymbol() {
  return (
    <Box position="relative" width="element.lg" height="element.lg">
      <Box
        backgroundColor="transparent"
        borderRadius="50%"
        border="1.5px solid"
        borderColor="fg"
        width="element.lg"
        height="element.lg"
      />
    </Box>
  );
}

export function SelectedRadioSymbol() {
  return (
    <Box position="relative" width="element.lg" height="element.lg">
      <Flex
        justifyContent="center"
        alignItems="center"
        backgroundColor="transparent"
        borderRadius="50%"
        border="1.5px solid"
        borderColor="primary.800"
        width="element.lg"
        height="element.lg"
      >
        <Box
          borderRadius="50%"
          backgroundColor="primary.800"
          width="element.sm"
          h="element.sm"
        />
      </Flex>
    </Box>
  );
}
